



































































import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import { getProductList } from '@/api/products'

@Component({
  name: 'ProductList',
  components: {}
})
/* eslint-disable @typescript-eslint/camelcase */
export default class extends Vue {
  private tableDataLoading = true
  private noEntriesMessage = 'Daten konnten nicht geladen werden.'
  private items: any[] = []
  private search = ''
  private sortStyle = 0
  private stock_states = [
    { name: 'Auf Lager', color: 'green', value: 1 },
    { name: 'Nicht auf Lager', color: 'red', value: 2 },
    { name: 'Vorbestellung', color: '#41aabc', value: 4 }
  ]
  StockState(input: number) {
    const c = this.stock_states.find(state => {
      if (state.value == input) return state
    })
    if (c != undefined) return c
    else return { name: 'error', color: 'purple', value: '-1' }
  }
  openArticleSummary(row: any) {
    console.log(row)
    this.$router.push({ path: `/product/summary/${row.product_id}` })
  }
  created() {
    this.getProductEntries()
  }
  private createNewProduct() {
    this.$router.push({ path: '/product/new' })
  }
  async getProductEntries() {
    try {
      const answer = await getProductList()
      console.log(answer.data)
      if (answer.data != null && answer.data.length != 0) {
        for (let index = 0; index < answer.data.length; index++) {
          const element = answer.data[index]
          const myItem = {
            product_id: element.product_id,
            name: element.product_description[0].name,
            stock_quantity: element.stock_quantity,
            stock_state: this.StockState(element.stock_status_id),
            viewed: element.viewed,
            orders: 0, //TODO
            orders_open: 0, //TODO
            price: element.price,
            status: 0, // TODO
            date_added: element.date_added
          }
          this.items.push(myItem)
        }
      }
      this.noEntriesMessage = 'Keine Daten auf dem Server vorhanden.'
      this.tableDataLoading = false
    } catch (error) {
      if (error.toString().includes('404')) {
        this.tableDataLoading = false
      } else if (error.toString().includes('403')) {
        this.noEntriesMessage = 'Keine Berechtigung.'
        this.tableDataLoading = false
        this.$store.state.authorized = false
        this.$router.push({ path: '/' })
      } else {
        console.log(error)
        this.tableDataLoading = false
      }
    }
  }
  private headers = [
    {
      sortable: true,
      text: 'ID',
      value: 'product_id'
    },
    {
      sortable: true,
      text: 'Name',
      value: 'name'
    },
    {
      sortable: true,
      text: 'Auf Lager',
      value: 'stock_quantity'
    },
    {
      sortable: true,
      text: 'Lagerstatus',
      value: 'stock_state',
      align: 'right'
    },
    {
      sortable: true,
      text: 'Angesehen',
      value: 'viewed'
    },
    {
      sortable: true,
      text: 'Bestellungen',
      value: 'orders'
    },
    {
      sortable: true,
      text: 'Offen',
      value: 'orders_open'
    },
    {
      sortable: true,
      text: 'Preis',
      value: 'price'
    },
    {
      sortable: true,
      text: 'Status',
      value: 'status'
    },
    {
      sortable: true,
      text: 'Einstelldatum',
      value: 'date_added'
    }
  ]

  // {
  //   name: 'Dakota Rice',
  //   country: 'Niger',
  //   city: 'Oud-Tunrhout',
  //   salary: '$35,738'
  // },
  // {
  //   name: 'Minerva Hooper',
  //   country: 'Curaçao',
  //   city: 'Sinaai-Waas',
  //   salary: '$23,738'
  // },
  // {
  //   name: 'Sage Rodriguez',
  //   country: 'Netherlands',
  //   city: 'Overland Park',
  //   salary: '$56,142'
  // },
  // {
  //   name: 'Philip Chanley',
  //   country: 'Korea, South',
  //   city: 'Gloucester',
  //   salary: '$38,735'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Doris Greene',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kārnten',
  //   salary: '$63,542'
  // },
  // {
  //   name: 'Mason Porter',
  //   country: 'Chile',
  //   city: 'Gloucester',
  //   salary: '$78,615'
  // }
  async myfunction() {
    const answer = await axios.get(process.env.VUE_APP_BASE_URL + 'api/')
    console.log(answer)
  }
}
